const axios = require('axios')

export const requestFeedback = params => {
  const uri = `/notification/v1/report`
  return axios.post(uri, params)
}
